import * as React from 'react';
import classNames from 'classnames';
import {withI18n, WithI18nProps} from '@shopify/react-i18n';
import {preventEventBubbling} from 'components/UIKit/utilities';
import {Card, Link, Flex, Text} from 'components/UIKit';
import styles from './CategoryCard.scss';
import * as locales from './locales';

export interface CategoryCardProps {
  path: string;
  title: string;
  imageUrl: string;
  className?: string;
  listingCount?: number;
}

export class CategoryCardComponent extends React.Component<CategoryCardProps & WithI18nProps> {
  handleCardClick = () => {
    const {path} = this.props;
    window.location.pathname = path;
  };

  render() {
    const {path, title, imageUrl, className, listingCount, i18n} = this.props;

    return (
      <Card imageUrl={imageUrl} onClick={this.handleCardClick} className={className}>
        <Link
          url={path}
          type="h3"
          text={title}
          className={styles.Heading}
          onClick={preventEventBubbling}
        />
        <Flex
          wrapperComponent="dl"
          wrap="wrap"
          justify-content="space-between"
          className={styles.NoMargin}
        >
          <Text
            text={i18n.translate('totalBusinesses')}
            className={classNames(styles.Stat, styles.Dt)}
            component="dt"
            secondary
          />
          <Text
            text={listingCount}
            className={classNames(styles.Stat, styles.Dd)}
            component="dd"
            align="right"
          />
        </Flex>
      </Card>
    );
  }
}

export const CategoryCard = withI18n({
  id: 'CategoryCard',
  fallback: locales.en,
})(CategoryCardComponent);

export default CategoryCard;
